import {
    AsLeftTableF65Hmi2Inst1Formula,
    AsLeftTableF63Hmi2Inst3Formula,
    AsLeftTableF78Deviation2Eu1Formula,
    AsLeftTableF79Deviation2Eu2Formula,
    AsLeftTableF80Deviation2Eu3Formula,
    TestResultF81AsLeftResultFormula
} from './P871.formula';
import { paddingAF } from '../M71/M71.data';
import { AsLeftF64Hmi2Inst2Formula } from '../P64/P64.formulas';
import { isEnabledcondition } from '../M611/M611.data';
import { Result } from 'journeys/portal/Forms/Sections.constants';

export const asLeftTestTableSectionDataP871 = (selectedTag, formData) => {
    const disableField = formData.F62SensorTrimNeed === 'NO';
    return {
        rows: [
            {
                key: 1,
                fields: [{
                    key: 'AsleftTest',
                    label: 'As-Left Test',
                    isLabel: true,
                    xs: 12,
                    fontWeight: '700',
                    padding: '5px 0 0 8px'
                }]
            },
            {
                key: 2,
                fields: [{
                    key: 'SimulationPoints',
                    label: 'Simulation Points',
                    isLabel: true,
                    xs: 2,
                    fontWeight: '700',
                    labelWidth: '100%',
                    padding: '5px 0 5px 8px',
                    fontSize: '9pt'
                },
                {
                    key: 'TestDeviceIndication',
                    label: 'Test Device Indication',
                    isLabel: true,
                    xs: 2,
                    fontWeight: '700',
                    labelWidth: '100%',
                    textAlign: 'center',
                    marginTop: '15px',
                    padding: paddingAF,
                    fontSize: '9pt'
                },
                {
                    key: 'TXReading',
                    label: 'TX Reading',
                    isLabel: true,
                    xs: 2,
                    fontWeight: '700',
                    textAlign: 'center',
                    labelWidth: '100%',
                    marginTop: '15px',
                    padding: paddingAF,
                    fontSize: '9pt'
                },
                {
                    key: 'HMIReading',
                    label: 'HMI Reading',
                    isLabel: true,
                    xs: 2,
                    fontWeight: '700',
                    labelWidth: '100%',
                    textAlign: 'center',
                    marginTop: '15px',
                    padding: paddingAF,
                    fontSize: '9pt'
                },
                {
                    key: 'mAReading',
                    label: 'mA Reading',
                    isLabel: true,
                    xs: 2,
                    fontWeight: '700',
                    labelWidth: '100%',
                    textAlign: 'center',
                    marginTop: '15px',
                    padding: paddingAF,
                    fontSize: '9pt'
                },
                {
                    key: 'Deviation',
                    label: 'Deviation (EU)',
                    isLabel: true,
                    xs: 2,
                    fontWeight: '700',
                    textAlign: 'center',
                    marginTop: '15px',
                    padding: paddingAF,
                    fontSize: '9pt',
                }]
            },
            {
                key: 3,
                fields: [{
                    key: 'F63Hmi2Inst1',
                    value: isEnabledcondition(AsLeftTableF65Hmi2Inst1Formula(formData), disableField),
                    isDisabled: disableField,
                    xs: 2,
                    width: '100%',
                    labelWidth: '0',
                    readOnly: true,
                    height: '1.2rem',
                    borderRight: '0',
                    borderLeft: '0',
                    borderBottom: '0',
                    marginLeft: '4px'
                },
                {
                    key: 'F66TestModule2Reading1',
                    value: isEnabledcondition(formData.F66TestModule2Reading1, disableField),
                    isRequired: !disableField,
                    isDisabled: disableField,
                    readOnly: disableField,
                    xs: 2,
                    type: 'number',
                    maxLength: '10',
                    width: '100%',
                    labelWidth: '0',
                    textAlign: 'center',
                    height: '1.2rem',
                    borderRight: '0',
                    borderBottom: '0'
                },
                {
                    key: 'F69Tx2Reading1',
                    value: isEnabledcondition(formData.F69Tx2Reading1, disableField),
                    isRequired: !disableField,
                    isDisabled: disableField,
                    readOnly: disableField,
                    xs: 2,
                    type: 'number',
                    maxLength: '10',
                    width: '100%',
                    labelWidth: '0',
                    textAlign: 'center',
                    height: '1.2rem',
                    borderRight: '0',
                    borderBottom: '0'
                },
                {
                    key: 'F72Hmi2Reading1',
                    value: isEnabledcondition(formData.F72Hmi2Reading1, disableField),
                    isRequired: !disableField,
                    isDisabled: disableField,
                    readOnly: disableField,
                    type: 'number',
                    maxLength: '10',
                    xs: 2,
                    width: '100%',
                    labelWidth: '0',
                    textAlign: 'center',
                    height: '1.2rem',
                    borderRight: '0',
                    borderBottom: '0'
                },
                {
                    key: 'F75MA2Reading1',
                    value: isEnabledcondition(formData.F75MA2Reading1, disableField),
                    isRequired: !disableField,
                    isDisabled: disableField,
                    readOnly: disableField,
                    type: 'number',
                    maxLength: '10',
                    xs: 2,
                    width: '100%',
                    labelWidth: '0',
                    textAlign: 'center',
                    height: '1.2rem',
                    borderBottom: '0',
                    borderRight: '0',
                },
                {
                    key: 'F78Deviation2Eu1',
                    value: isEnabledcondition(AsLeftTableF78Deviation2Eu1Formula(formData), disableField),
                    isDisabled: disableField,
                    readOnly: true,
                    xs: 2,
                    textAlign: 'center',
                    width: '100%',
                    labelWidth: '0',
                    height: '1.2rem',
                    borderBottom: '0',
                    borderRight: '0',
                    inputMarginRight: '4px',
                }]
            },
            {
                key: 4,
                fields: [{
                    key: 'F64Hmi2Inst2',
                    value: isEnabledcondition(AsLeftF64Hmi2Inst2Formula(formData), disableField),
                    isDisabled: disableField,
                    xs: 2,
                    width: '100%',
                    labelWidth: '0',
                    readOnly: true,
                    height: '1.2rem',
                    borderRight: '0',
                    borderLeft: '0',
                    borderBottom: '0',
                    marginLeft: '4px'
                },
                {
                    key: 'F67TestModule2Reading2',
                    value: isEnabledcondition(formData.F67TestModule2Reading2, disableField),
                    isRequired: !disableField,
                    isDisabled: disableField,
                    readOnly: disableField,
                    maxLength: '10',
                    xs: 2,
                    type: 'number',
                    width: '100%',
                    labelWidth: '0',
                    textAlign: 'center',
                    height: '1.2rem',
                    borderRight: '0',
                    borderBottom: '0'
                },
                {
                    key: 'F70Tx2Reading2',
                    value: isEnabledcondition(formData.F70Tx2Reading2, disableField),
                    isRequired: !disableField,
                    isDisabled: disableField,
                    readOnly: disableField,
                    xs: 2,
                    type: 'number',
                    maxLength: '10',
                    width: '100%',
                    labelWidth: '0',
                    textAlign: 'center',
                    height: '1.2rem',
                    borderRight: '0',
                    borderBottom: '0'
                },
                {
                    key: 'F73Hmi2Reading2',
                    value: isEnabledcondition(formData.F73Hmi2Reading2, disableField),
                    isRequired: !disableField,
                    isDisabled: disableField,
                    readOnly: disableField,
                    xs: 2,
                    type: 'number',
                    maxLength: '10',
                    width: '100%',
                    labelWidth: '0',
                    textAlign: 'center',
                    height: '1.2rem',
                    borderRight: '0',
                    borderBottom: '0'
                },
                {
                    key: 'F76MA2Reading2',
                    value: isEnabledcondition(formData.F76MA2Reading2, disableField),
                    isRequired: !disableField,
                    isDisabled: disableField,
                    readOnly: disableField,
                    xs: 2,
                    type: 'number',
                    maxLength: '10',
                    width: '100%',
                    labelWidth: '0',
                    textAlign: 'center',
                    height: '1.2rem',
                    borderBottom: '0',
                    borderRight: '0',
                },
                {
                    key: 'F79Deviation2Eu2',
                    value: isEnabledcondition(AsLeftTableF79Deviation2Eu2Formula(formData), disableField),
                    isDisabled: disableField,
                    readOnly: true,
                    xs: 2,
                    textAlign: 'center',
                    width: '100%',
                    labelWidth: '0',
                    height: '1.2rem',
                    borderBottom: '0',
                    borderRight: '0',
                    inputMarginRight: '4px'
                }]
            },
            {
                key: 5,
                fields: [{
                    key: 'F65Hmi2Inst3',
                    value: isEnabledcondition(AsLeftTableF63Hmi2Inst3Formula(formData), disableField),
                    isDisabled: disableField,
                    xs: 2,
                    width: '100%',
                    labelWidth: '0',
                    readOnly: true,
                    height: '1.2rem',
                    borderRight: '0',
                    borderLeft: '0',
                    marginLeft: '4px'
                },
                {
                    key: 'F68TestModule2Reading3',
                    value: isEnabledcondition(formData.F68TestModule2Reading3, disableField),
                    isRequired: !disableField,
                    isDisabled: disableField,
                    readOnly: disableField,
                    maxLength: '10',
                    xs: 2,
                    type: 'number',
                    width: '100%',
                    labelWidth: '0',
                    textAlign: 'center',
                    height: '1.2rem',
                    borderRight: '0',
                },
                {
                    key: 'F71Tx2Reading3',
                    value: isEnabledcondition(formData.F71Tx2Reading3, disableField),
                    isRequired: !disableField,
                    isDisabled: disableField,
                    readOnly: disableField,
                    xs: 2,
                    type: 'number',
                    maxLength: '10',
                    width: '100%',
                    labelWidth: '0',
                    textAlign: 'center',
                    height: '1.2rem',
                    borderRight: '0',
                },
                {
                    key: 'F74Hmi2Reading3',
                    value: isEnabledcondition(formData.F74Hmi2Reading3, disableField),
                    isRequired: !disableField,
                    isDisabled: disableField,
                    readOnly: disableField,
                    type: 'number',
                    maxLength: '10',
                    xs: 2,
                    width: '100%',
                    labelWidth: '0',
                    textAlign: 'center',
                    height: '1.2rem',
                    borderRight: '0',
                },
                {
                    key: 'F77MA2Reading3',
                    value: isEnabledcondition(formData.F77MA2Reading3, disableField),
                    isRequired: !disableField,
                    isDisabled: disableField,
                    readOnly: disableField,
                    type: 'number',
                    maxLength: '10',
                    xs: 2,
                    width: '100%',
                    labelWidth: '0',
                    textAlign: 'center',
                    height: '1.2rem',
                    borderRight: '0',
                },
                {
                    key: 'F80Deviation2Eu3',
                    value: isEnabledcondition(AsLeftTableF80Deviation2Eu3Formula(formData), disableField),
                    isDisabled: disableField,
                    readOnly: true,
                    xs: 2,
                    textAlign: 'center',
                    width: '100%',
                    labelWidth: '0',
                    height: '1.2rem',
                    borderRight: '0',
                    inputMarginRight: '4px',
                }]
            },
            {
                key: 6,
                fields: [{
                    key: 'NoData2',
                    xs: 8,
                    isLabel: true,
                    padding: '5px 25px 18.5px 0'
                },
                {
                    key: 'F81AsLeftResultLabel',
                    value: Result.AS_LEFT_RESULT_LABEL,
                    readOnly: true,
                    xs: 2,
                    isLabelBold: true,
                    textAlign: 'end',
                    labelWidth: '0',
                    width: '100%',
                    height: '1.1rem',
                    borderRight: '0',
                    borderTop: '0',
                    borderLeft: '0',
                    borderBottom: '0',
                },
                {
                    key: 'F81AsLeftResult',
                    value: TestResultF81AsLeftResultFormula(formData),
                    readOnly: true,
                    isCalculatedNew: true,
                    isDisabled: disableField,
                    xs: 2,
                    labelWidth: '0',
                    width: '100%',
                    height: '1.1rem',
                    borderTop: disableField ? '' : '0',
                    inputMarginRight: '4px',
                    borderBottom: '0',
                    marginBottom: '4px',
                    textAlign: 'center',
                    borderRight: '0'
                }]
            }]
    };
};
